<template>
  <div>
    <div class="f x lg--mb-5 sm--mb-4 fw">
      <ValidationProvider
        name="first name"
        rules="required|alpha_dash"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="firstName"
          type="text"
          name="address[first_name]"
          :required="true"
          label="First Name"
          :error="errors && errors[0]"
          containerClass="lg--f-1 sm--x sm--mb-4"
        />
      </ValidationProvider>

      <ValidationProvider
        name="last name"
        rules="required|alpha_dash"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="lastName"
          type="text"
          name="address[last_name]"
          :required="true"
          label="Last Name"
          :error="errors && errors[0]"
          containerClass="lg--f-1 sm--x lg--pl-4"
        />
      </ValidationProvider>
    </div>

    <div class="lg--mb-5 sm--mb-4">
      <ValidationProvider
        name="address"
        rules="required"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="address1"
          type="text"
          name="address[address1]"
          :required="true"
          label="Address 1"
          :error="errors && errors[0]"
        />
      </ValidationProvider>
    </div>

    <div class="lg--mb-5 sm--mb-4">
      <ValidationProvider
        name="address 2"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="address2"
          type="text"
          name="address[address2]"
          label="Address 2"
          :error="errors && errors[0]"
        />
      </ValidationProvider>
    </div>

    <div class="f x lg--mb-5 sm--mb-4 fw">
      <ValidationProvider
        name="city"
        rules="required"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="city"
          type="text"
          name="address[city]"
          :required="true"
          label="City"
          :error="errors && errors[0]"
          containerClass="lg--f-1 sm--x sm--mb-4"
        />
      </ValidationProvider>

      <div class="lg--f-1 sm--x lg--pl-4">
        <slot name="country"></slot>
      </div>
    </div>

    <slot name="province"></slot>

    <div class="f x lg--mb-5 sm--mb-4 fw">
      <ValidationProvider
        name="zip code"
        rules="required|alpha_num"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="zip"
          type="text"
          name="address[zip]"
          :required="true"
          label="Zip Code"
          :error="errors && errors[0]"
          containerClass="lg--f-1 sm--x sm--mb-4"
        />
      </ValidationProvider>

      <ValidationProvider
        name="phone"
        rules="required|alpha_num"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="phone"
          type="required|alpha_num"
          name="address[phone]"
          :required="true"
          label="Phone"
          :error="errors && errors[0]"
          containerClass="lg--f-1 sm--x lg--pl-4"
        />
      </ValidationProvider>
    </div>

    <input
      class="submit-button plaid-l fs-12 address-form-submit"
      value="ADD ADDRESS"
      type="submit"
    />
  </div>
</template>

<script>
export default {
  name: "addresses-add-form",
  props: {},
  data() {
    return {
      firstName: "",
      lastName: "",
      address1: "",
      address2: "",
      city: "",
      zip: "",
      phone: "",
    };
  },
  mounted() {
    const countrySelector = document.querySelector("#AddressCountryNew");

    const countryPlaceholder = document.querySelector('option[value="---"]');
    countryPlaceholder.innerHTML = "Country";
    countryPlaceholder.setAttribute("disabled", true);

    countrySelector.addEventListener("change", function () {
      countrySelector.style.color = "#34312E";
      countrySelector.style.fontFamily = "Plaid-XS-Web";
      countrySelector.style.fontSize = "16px";
      countrySelector.style.textTransform = "unset";

      new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        {
          hideElement: null,
        }
      );
    });

    new Shopify.CountryProvinceSelector(
      "AddressCountryNew",
      "AddressProvinceNew",
      {
        hideElement: null,
      }
    );
  },
};
</script>
